// Instalar la web como app desde el navegador del celular (sin Google Play).
// Chrome avisa con "beforeinstallprompt" apenas carga la página, así que se escucha
// desde el arranque y se guarda para cuando el usuario toque "Instalar la app".
let aviso = null;
const oyentes = new Set();
const avisar = () => oyentes.forEach((fn) => fn());

export function iniciarInstalacionWeb() {
  if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
    window.addEventListener('load', () => navigator.serviceWorker.register('/service-worker.js').catch(() => {}));
  }
  window.addEventListener('beforeinstallprompt', (e) => { e.preventDefault(); aviso = e; avisar(); });
  window.addEventListener('appinstalled', () => { aviso = null; avisar(); });
}

export const puedeInstalarDirecto = () => Boolean(aviso);

export function alCambiarInstalacion(fn) {
  oyentes.add(fn);
  return () => oyentes.delete(fn);
}

// Abre el cartel de instalación del navegador. Devuelve true si la instaló.
export async function instalarDirecto() {
  if (!aviso) return false;
  const e = aviso;
  aviso = null;
  e.prompt();
  const { outcome } = await e.userChoice;
  avisar();
  return outcome === 'accepted';
}

// Ya se está usando instalada (abierta desde el ícono)
export const abiertaComoApp = () =>
  window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
